module.exports = __webpack_public_path__ + "img/refresh.d8416f57.svg";